import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import { IBetData } from "../../../core/src/server/data/IBetData";
import App from "../../../core/src/App";
import { BetConfigType } from "../../../core/src/utils/ConfigType";
import BetModel from "../../../core/src/model/BetModel";
import Configs from "../../vendorConfigs/Configs";
import IPaytableMapItem from "../../../core/src/managers/contracts/configurations/IPaytableMapItem";
import * as currency_config from "../../../core/src/baseConfigs/currency-config.json";
import CurrencyUtils from "../../../core/src/utils/CurrencyUtils";

export default class BetDataParser implements IBaseDataParser<IBetData> {
    check(data: any): boolean {
        return data?.config;
    }

    parse(data): IBetData[] {
        // Parsing the paytable map
        let paytableMap: IPaytableMapItem[] = [];

        Configs.settings.ptMap = paytableMap;

        BetModel.betDivisor = data.config.creditsPerBet || 1;
        BetModel.currencyRate = /*data.data.gameData.currencyRate ||*/ 1;
        BetModel.currencyMultiplier = /*data.data.gameData.currencyMultiplier =*/ 1;
        let bets:number[] = data.limits.legalBets;
        let coinSize = data.limits.defaultBet;
        let currencyISO = data.stats.currency || "EUR";
        const decimals = currency_config[currencyISO].decimals || 2;
        const symbol = currency_config[currencyISO].symbol || "€";
        const multi = currency_config[currencyISO].defaultMultiplier || 1;
        const currencyLocalization = CurrencyUtils.createCurrencyLocalization(
            currencyISO,
            symbol,
            decimals,
            multi,
            data.country);

        BetModel.setCurrency(currencyLocalization);

        let result: IBetData = {
            betMultipliers: [1],
            // creditValues:  Utils.parseStringifiedListOfNumbers(data.Response.Bet.attributes.validChips),
            // betMultipliers: Utils.parseStringifiedListOfNumbers(
            //     data.Response.Bet.attributes.validChips
            // ),
            currentBetMultiplier:  1,
            creditValues: bets,
            coinSize,
            coinSizeIndex:bets.indexOf(coinSize),
            minLinesAllowed: 1,
            maxLinesAllowed: 1,
            currency:{
                decimals: currencyLocalization.currency.decimals,
                symbol: currencyLocalization.currency.symbol,
                ISO: currencyLocalization.currency.ISO
            },
            allPossibleBets: this.parsePossibleBets(
                bets,
                1
            ),
            numLines: 1,
        };

        return [result];
    }

    parsePossibleBets(
        bets,
        linesCount
    ): { coinIndex: number; multiplier: number; value: number }[] {
        let result = [];
        // let values = [];
        let betConfig = App.assets.getConfig("betConfig") as BetConfigType;
        // let validValues = betConfig.validBets;
        // let multipliers = Utils.parseStringifiedListOfNumbers(data.validChips);
        bets.forEach((bet,betIndex) => {
            // multipliers.forEach((val, coinIndex) => {
                let currentValue = bet * linesCount;
                // if (values.indexOf(currentValue) == -1 &&
                //     (!validValues || validValues.indexOf(currentValue) != -1)
                // ) {
                    // values.push(currentValue);
                    result.push({
                        total:currentValue,
                        coinIndex: betIndex,
                        multiplier: 1,
                        value:currentValue,
                    });
                // }
            // });
        });

        result = result.sort((a, b) => {
            if (a.total > b.total) {
                return 1;
            } else if (a.total < b.total) {
                return -1;
            }
            return 0;
        })

        return result;
    }
}
